// Display form for a shop phone number: NANP numbers read as "(xxx) xxx-xxxx",
// anything else (international, extensions) is shown as stored.
export const formatPhoneDisplay = (value) => {
  if (!value) return '';
  const raw = String(value).trim();
  let digits = raw.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
  if (digits.length !== 10) return raw;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

// Dialable tel: URI that keeps only digits and a leading-country "+".
export const phoneHref = (value) => `tel:${String(value).replace(/[^\d+]/g, '')}`;
